import { defineStore } from 'pinia'

export const useTermsStore = defineStore('terms', {
  state: () => ({
    items: ['Term 1', 'Term 2', 'Term 3', 'Term 4'],
  })
})